import React from 'react';
import './AppLayout.less';
import mainLogo from '../../assets/smartdrive_logo.svg';
import MenuBar from './MenuBar';
import EventSearch from './EventSearch';
import { Row, Col, Icon, Layout, AppLocaleProvider } from 'sd-ui-components';
import { observer, inject } from 'mobx-react';
import history from '../../history';
import { isWebview } from '../../utils/UserAgentHelper';
import { SlideDown } from 'react-slidedown';
import { useOidc } from '@axa-fr/react-oidc';
import 'react-slidedown/lib/slidedown.css';
import showCookieSettings from '../../utils/showCookieSettings';

const { Header, Content, Footer } = Layout;
const { FormattedHTMLMessage } = AppLocaleProvider;

@inject('AuthStore')
@inject('NotificationsStore')
@inject('ConfigStore')
@observer
class AppLayout extends React.Component {
  embeddedInWebview = isWebview();

  state = {
    collapsed: true,
    isSso: false,
    isEventSearchOpen: false
  };

  constructor(props) {
    super(props);
    const { isAuthenticated, logout } = useOidc();
    if (!this.props.AuthStore.isAuthenticated) {
      if (isAuthenticated) {
        logout('/');
        this.props.AuthStore.removeStorageForLogout();
      } else {
        this.props.AuthStore.logout();
      }
    } else {
      this.props.AuthStore.initUserInfo();
    }

    this.checkForSso();
  }

  checkForSso = async () => {
    const isSso = await this.props.AuthStore.isSso();
    this.setState({ isSso: isSso });
  };

  toggleSidebar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      isEventSearchOpen: false,
      isProduction: true
    });
  };

  toggleEventSearch = () => {
    this.setState({
      isEventSearchOpen: !this.state.isEventSearchOpen,
      collapsed: true
    });
  };

  onMenuStateChange = open => {
    this.setState({
      collapsed: !open
    });
  };

  goToHomePage = () => {
    history.push('/safety');
  };

  handleNavigateToEventFromSearch = eventNumber => {
    this.setState({ isEventSearchOpen: false }, () => {
      history.replace(`/eventSearch/${encodeURIComponent(eventNumber)}`);
    });
  };

  componentWillUnmount = () => {
    this.props.NotificationsStore.clearNotifications();
  };

  render() {
    return (
      <div className={`app-layout-root ${this.props.className || ''}`}>
        {!this.embeddedInWebview &&
          !this.state.isSso &&
          !this.props.AuthStore.loginInfo['appLauncher'] && (
            <MenuBar
              isOpen={!this.state.collapsed}
              onStateChange={this.onMenuStateChange}
            />
          )}

        <Layout className="app-layout-layout">
          <Header className={`app-layout-header`}>
            <div
              className={`header-bar-event-search-overlay ${
                !this.state.isEventSearchOpen ? 'hidden' : ''
              }`}
              style={{
                opacity: this.state.isEventSearchOpen ? 1 : 0
              }}
              onClick={this.toggleEventSearch}
            />

            <Row>
              <Col span={2} className="app-layout-header-menu-container">
                {!this.embeddedInWebview &&
                  !this.state.isSso &&
                  !this.props.AuthStore.loginInfo['appLauncher'] && (
                    <Icon
                      className="app-layout-header-menu-icon"
                      size={30}
                      icon={'menu'}
                      onClick={this.toggleSidebar}
                    />
                  )}
              </Col>
              <Col span={20} className="app-layout-header-col-main">
                {!this.props.AuthStore.loginInfo['appLauncher'] && (
                  <img
                    src={mainLogo}
                    alt="Smartdrive"
                    className="app-layout-header-logo"
                    onClick={this.goToHomePage}
                  />
                )}
              </Col>
              <Col span={2} className="app-layout-header-search-col">
                <div className="event-search-icon-container">
                  <Icon
                    className="app-layout-header-menu-icon"
                    size={20}
                    icon={'magnifier'}
                    onClick={this.toggleEventSearch}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <SlideDown className="event-search-slidedown">
                  {this.state.isEventSearchOpen && (
                    <EventSearch
                      onNavigateToEvent={this.handleNavigateToEventFromSearch}
                    />
                  )}
                </SlideDown>
                <div
                  className={`event-search-overlay ${
                    !this.state.isEventSearchOpen ? 'hidden' : ''
                  }`}
                  style={{
                    opacity: this.state.isEventSearchOpen ? 1 : 0
                  }}
                  onClick={this.toggleEventSearch}
                />
              </Col>
            </Row>
          </Header>
          <Content className="app-layout-content sd-primary-color-6-background">
            {this.props.children}
          </Content>
          <Footer className="app-layout-footer">
            <a href={this.props.ConfigStore.config.homeUrl} target="_blank">
              <FormattedHTMLMessage
                id="App.Footer.Home"
                defaultMessage="Home"
              />
            </a>
            {' | '}
            <a
              href={this.props.ConfigStore.config.privacyPolicyUrl}
              target="_blank"
            >
              <FormattedHTMLMessage
                id="App.Footer.PrivacyPolicy.ExceptUkEu"
                defaultMessage="Privacy Policy (except UK/EU)"
              />
            </a>
            {' | '}
            <a
              href={this.props.ConfigStore.config.privacyPolicyUrlUkEu}
              target="_blank"
            >
              <FormattedHTMLMessage
                id="App.Footer.PrivacyPolicy.UkEu"
                defaultMessage="Privacy Policy UK/EU"
              />
            </a>
            {' | '}
            <a
              href={this.props.ConfigStore.config.privacyNoticeUrl}
              target="_blank"
            >
              <FormattedHTMLMessage
                id="App.Footer.PrivacyNotice"
                defaultMessage="Privacy Notice"
              />
            </a>
            {' | '}
            {!this.props.AuthStore.loginInfo['appLauncher'] && (
              <a onClick={showCookieSettings} target="_blank">
                <FormattedHTMLMessage
                  id="App.Footer.CookiePreferences"
                  defaultMessage="Cookie Preferences"
                />
              </a>
            )}
            {!this.props.AuthStore.loginInfo['appLauncher'] && ' | '}
            <FormattedHTMLMessage
              id="App.Copyright"
              description="Application copyright"
              defaultMessage="&copy; {copyrightYear} SmartDrive Systems, Inc. All rights reserved."
              values={{
                copyrightYear: new Date().getFullYear()
              }}
            />
          </Footer>
        </Layout>
      </div>
    );
  }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/containers/AppLayout/AppLayout.jsx